var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgProfileIcon = function SvgProfileIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C3.589 0 0 3.589 0 8s3.589 8 8 8 8-3.589 8-8-3.589-8-8-8Zm4.465 12.936c-.442-1.315-1.666-2.27-3.132-2.27H6.667c-1.466 0-2.688.955-3.131 2.27A6.644 6.644 0 0 1 1.333 8 6.674 6.674 0 0 1 8 1.333 6.674 6.674 0 0 1 14.667 8a6.644 6.644 0 0 1-2.202 4.936Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.999 3.333A2.667 2.667 0 0 0 5.332 6v.667a2.667 2.667 0 0 0 5.333 0V6A2.667 2.667 0 0 0 8 3.333Z",
    fill: "#fff"
  })));
};

export default SvgProfileIcon;